import React from "react";
import { Button, Layout } from 'antd';
import styled from "styled-components";

const PrivacyDiv = styled.div`
  width: 85%; 
  margin: auto;
  background-color: #f4f4f4; 
  padding-bottom: 10px;
  padding-left: 25px; 
  padding-right: 25px;
`

const PravacyP = styled.p`
  color: #4c4c4c;
  text-align: left;
`

const PrivacyPolicy = (props) => {
  return (
    <Layout style={{background: "white"}}>
      <PrivacyDiv>
        <PravacyP>
          By continuing, you will be asked to
          acknowledge and accept the Data Policy
          of this channel.
          <br/><br/>
          In compliance with Republic Act 10173 also known as the Data Privacy Act of 2012, and its Implementing Rules and 
          Regulations, we need your Consent to: (a) allow us to collect, process, transfer or share, your personal and health 
          information, with MediCard’s officers, directors, employees, agents, consultants, contractors, representatives, affiliated 
          companies within AIA Group and recognized service providers which include MediCard’s accredited hospitals/clinics, 
          physicians, diagnostic service centers, and other allied health professionals who may also be responsible in rendering 
          appropriate medical services to you; and (b) to share utilization data with your Principal (in case of dependents) and the 
          Principal Member’s Company (for member’s under a corporate health insurance) for the proper administration of the 
          Company’s health benefits program.<br/><br/>

          You understand that MediCard and its recognized service providers may be required by the government under relevant 
          laws and regulations to disclose such information. Except to the extent required by law or any government agencies, 
          MediCard shall properly dispose of the information in case MediCard no longer needs it for any of the purposes above.
          <br/><br/>

          You further understand that withholding or withdrawal of this Consent shall entitle MediCard to refuse, or shall relieve 
          MediCard from, its obligation to deliver the appropriate services to you.
          <br/><br/>

          You are afforded certain rights and protection in accordance with the said Act and you may visit <a target="_blank" rel="noopener noreferrer"  href="https://www.medicardphils.com/privacy-statement"><span className="email-part"> Privacy Statement </span> </a> or email
          <a href="mailto:privacy@medicardphils.com" target="_blank" rel="noopener noreferrer"><span className="email-part"> privacy@medicardphils.com</span></a>  for more information.

          <br/><br/>
          Tap the <b>GET STARTED</b> button to start our conversation.
        </PravacyP>
      </PrivacyDiv>
      <Button type="primary" 
        style = {{
          borderRadius: "0px",
          width:"85%",
          left:"7.5%",
          marginTop: "10px",
          height: "50px",
          marginBottom: "20px",
        }}
        onClick={()=> {
          props.triggerNextStep();
        }}> 
        Get Started   
      </Button>
    </Layout>
  )
}

export default PrivacyPolicy
